import "./Social.css"

const Social = () => {
	return (
		<div className="social">
			<a href="https://github.com/ezegonmac">
				<img src="icons/github_icon.svg" alt="github" />
			</a>
			<a href="https://codepen.io/ezquielgon2">
				<img src="icons/codepen_icon.svg" alt="codepen" />
			</a>
			<a href="https://www.linkedin.com/in/ezequiel-gonzalez-macho-329583223">
				<img src="icons/linkedin_icon.svg" alt="linkedin" />
			</a>
		</div>
	)
}

export default Social
